
const destino_input = "Por favor ingrese una ciudad de destino!";

const origen_input = "Por favor ingrese una ciudad de origen!";

const distancia_input = "Por favor ingrese la distancia en kilométros!";

export {destino_input, origen_input, distancia_input};